import notification from 'antd/lib/notification';
import 'antd/lib/notification/style/index';
import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

class Notification {
  success(title, text) {
    notification.success({
      message: title,
      description: text,
      duration: 3,
      placement: 'topRight',
      style: {
        borderRadius: 11,
        paddingRight: 45,
      }
    });
  };

  error(title, text) {
    // A notice titled "Info" is telling the user how something works, not reporting a
    // failure, so it must not arrive under the red cross whatever call site raised it.
    // Routed here rather than left to each caller so the rule holds for every one.
    if (String(title || '').trim().toLowerCase() === 'info') {
      return this.info(title, text);
    }
    notification.error({
      message: title,
      description: text,
      duration: 5,
      placement: 'topRight',
      style: {
        borderRadius: 11,
        paddingRight: 45,
      },
      key: text
    })
  };

  info(title, text) {
    notification.info({
      message: title,
      description: text,
      duration: 5,
      placement: 'topRight',
      style: {
        borderRadius: 11,
        paddingRight: 45,
      }
    });
  };

  warning(title, text) {
    notification.warning({
      message: title,
      description: text,
      duration: 5,
      placement: 'topRight',
      style: {
        borderRadius: 11,
        paddingRight: 45,
      }
    });
  };

  loading(key, text) {
    notification.open({
      key,
      message: (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <LoadingOutlined style={{ color: '#1089FF', fontSize: 16, marginRight: 10 }} spin />
          <span>{text}</span>
        </div>
      ),
      duration: 0,
      placement: 'topRight',
      closeIcon: <></>,
      style: {
        borderRadius: 11,
        paddingRight: 45,
      }
    });
  };

  close(key) {
    notification.close(key);
  }

  info(title, text) {
    notification.info({
      message: text ? title : (title || 'Info'),
      description: text,
      duration: 3,
      style: {
        borderRadius: 11,
      }
    });
  };

  hide() {
    notification.destroy();
  }
}


export default new Notification();
